import type { ChannelMiniEntity } from '@/features/channel/domain/entities/ChannelMiniEntity'
import type { RateType } from '../enums/RateType'

export class OrderRateReasonFilterEntity {
  id?: number
  minRate?: number
  maxRate?: number
  rateType?: RateType
  channel?: ChannelMiniEntity
  searchWord?: string
  page?: number
  limit?: number
  sortField?: string
  sortDescending?: boolean
}
